import { get, post, put } from "./api_helper"

export const getSpecificationAPI = params =>
  get("admin/master/specification/page", params)

export const getSpecificationListAPI = params =>
  get("admin/master/specification/list", params)

export const getSpecificationByIdAPI = id =>
  get(`admin/master/specification/${id}`)

export const postSpecificationAPI = data =>
  post("admin/master/specification", data)

export const putSpecificationAPI = (data, id) =>
  put(`admin/master/specification/${id}`, data)
